import React, { useState } from "react";
import { useDispatch } from "react-redux";
import CoreSpinner from "../../../app/core/components/CoreSpinner/CoreSpinner";
import GestionePraticheTable from "./GestionePraticheTable";
import GestioneDocumentFilter from "./GestioneDocumentFilter";
import praticheManagementSlice from "./gestisciPraticheSlice";
import CoreChip from "../../../app/core/components/CoreChip/CoreChip";
import { labelForFilterPracticeUser } from "../../../utils/functions/filters";
import { useGetPracticeManagementQuery } from "../../api/user/gestisciPraticheApi";
import { TABLE_ROWS_NUMBER } from "../../../utils/constants/tables";
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";
import CoreButtonHoverIcon from "../../../app/core/components/CoreButtonIcon/CoreButtonHoverIcon";
import { t } from "i18next";

const GestionePratichePage = () => {
  const [page, setPage] = useState({
    currentPage: 1,
    startRow: 0,
    endRow: TABLE_ROWS_NUMBER,
  });
  const [filter, setFilter] = useState({
    status: "",
    startDate: "",
    endDate: "",
  });
  const [orderDirection, setOrderDirection] = useState("desc");
  const [valueToOrderBy, setValueToOrderBy] = useState("createdAt");

  const dispatch = useDispatch();

  // Data from API
  const { data, isLoading, isFetching, refetch } =
    useGetPracticeManagementQuery({
      page,
      filter,
      orderDirection,
      valueToOrderBy,
    });

  const handleRemoveFilter = (f) => {
    let newFilter = { ...filter };
    Object.entries(newFilter).forEach(([k, v]) => {
      if (v === f) newFilter[k] = "";
    });
    setFilter(newFilter);
    dispatch(praticheManagementSlice.actions.setTableFilters(newFilter));
  };

  const handleRefecthDocuments = () => {
    refetch();
  };

  return (
    <>
      {isLoading ? (
        <CoreSpinner />
      ) : (
        <div className="flex flex-col">
          <h2>{t("ManagePractices")}</h2>
          <div>
            <div className="flex flex-row -mt-16 space-x-2 justify-end ">
              {Object.entries(filter).map(
                ([k, v]) =>
                  v !== "" && (
                    <CoreChip
                      color="warning"
                      key={v}
                      label={labelForFilterPracticeUser(k, v)}
                      variant="outlined"
                      onDelete={() => handleRemoveFilter(v)}
                    />
                  )
              )}
              <GestioneDocumentFilter
                filter={filter}
                setFilter={setFilter}
                slice={praticheManagementSlice}
              />
            </div>
            <div className="py-5">
              <CoreButtonHoverIcon
                onClick={handleRefecthDocuments}
                className="text-blue-500 m-1 flex flex-row space-x-2 border"
                testo={t("Refresh")}
                icon={<RefreshRoundedIcon className={`fill-blue-500`} />}
              />
            </div>
          </div>

          <GestionePraticheTable
            page={page}
            setPage={setPage}
            data={data?.Data}
            valueToOrderBy={valueToOrderBy}
            setValueToOrderBy={setValueToOrderBy}
            orderDirection={orderDirection}
            setOrderDirection={setOrderDirection}
            totalPages={Math.ceil(data?.Data?.count / TABLE_ROWS_NUMBER) || 1}
            isLoading={isLoading || isFetching}
          />
        </div>
      )}
    </>
  );
};

export default GestionePratichePage;
